import { render } from "./HelpPanel.vue?vue&type=template&id=4607be60"
import script from "./HelpPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/help/HelpPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4607be60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4607be60', __exports__)) {
    api.reload('4607be60', __exports__)
  }
  
  module.hot.accept("./HelpPanel.vue?vue&type=template&id=4607be60", () => {
    api.rerender('4607be60', render)
  })

}


export default __exports__